import * as size from './size.js'
import { fontDefault } from './preload.js'

export function gen(app, text, callback) {
    // Container 1
    const container = new PIXI.Container();

    // Text
    const rate = size.rateX();
    const fontSize = 40 * rate;
    const label = new PIXI.Text({ text,
        style: { fontFamily: fontDefault, fontSize, fill: 'white' } });
    label.anchor.x = 0.5;
    label.anchor.y = 0.53;

    // Button Base
    const marginX = fontSize * 1.6;
    const marginY = fontSize * 0.4;
    const base = new PIXI.Graphics();
    base.rect(0, 0, label.width + marginX * 2, label.height + marginY * 2);

    const gradientFill = new PIXI.FillGradient(0, 0, 0, label.height + marginY * 2);
    gradientFill.addColorStop(0,   0x441100);
    gradientFill.addColorStop(0.3, 0x882200);
    gradientFill.addColorStop(0.7, 0x882200);
    gradientFill.addColorStop(1,   0x441100);
    base.fill(gradientFill);

    base.stroke({ width: 2 * rate, color: 0xffbb00 });
    base.x = - base.width / 2;
    base.y = - base.height / 2;

    // Container 2
    container.addChild(base);
    container.addChild(label);
    container.x = app.renderer.width / 2;
    container.y = app.renderer.height / 2;
    app.stage.addChild(container);

    container.eventMode = 'static';
    container.cursor = 'pointer';
    let isClick = false;
    container.on('pointerdown', async () => {
        if (isClick) return;
        isClick = true;

        await anime.timeline({ targets: container.scale, easing: 'linear' })
        .add({ x: 1.04, y: 1.01, duration: 150 })
        .add({ x: 1, y: 1, duration: 150 })
        .add({ duration: 100}).finished;

        await callback();
        isClick = false;
    });

    return container;
}
